<template>

  <div :class="$style.container"
       v-loading.fullscreen.lock.body="loading"
       element-loading-text="拼命加载中"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
    <div :class="$style.header">
<!--      <span :class="$style.edit" @click.stop="handleEditClick">移除</span>-->
      <span :class="['iconfont', 'icon-touxiang', $style.avatar]" style="margin-right: 8px"></span>
      <div :class="$style.userInfo">
        <span style="font-size: 18px">{{info.last_name}}</span>
        <p v-if="info.gender && info.birthday && info.phone">{{info.gender | filtersex}} {{info.birthday | filtertime}}<i :class="['iconfont', 'icon-tel03', $style.tel]"></i>{{info.phone}}</p>
        <p v-if="!info.gender && info.birthday && info.phone">{{info.birthday | filtertime}}<i :class="['iconfont', 'icon-tel03', $style.tel]"></i>{{info.phone}}</p>
        <p v-if="!info.gender && !info.birthday && info.phone"><i :class="['iconfont', 'icon-tel03', $style.tel1]"></i>{{info.phone}}</p>
      </div>
    </div>
    <div :class="$style.body">
        <p>职务:
            <span :class="$style.date" v-if="info.title">{{info.title}}</span>
            <span :class="$style.date" v-else style="color: red">暂无</span>
        </p>
    </div>
<!--    <div :class="$style.body">-->
<!--      <p>开始销售日立时间: <span :class="$style.date">{{info.startSalesDate}}</span></p>-->
<!--    </div>-->
    <!-- 模态框 -->
<!--    <el-dialog-->
<!--            :visible.sync="showModal" :show-close="false"-->
<!--            width="50%" :class="$style.modal" class="a_modal"-->
<!--            :before-close="closeModal">-->
<!--      <div slot="title" :class="$style.title">-->
<!--        <span>编辑</span>-->
<!--        <div>-->
<!--          <el-button type="primary" size="small" @click.stop="handleSaveClick">保存</el-button>-->
<!--          <el-button type="danger" size="small" @click.stop="closeModal">取消</el-button>-->
<!--        </div>-->
<!--      </div>-->
<!--      <el-form :model="form" label-width="140px">-->
<!--        <el-form-item label="所在经销商">-->
<!--          <span>{{form.dealerName}}</span>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="所在门店">-->
<!--          <el-select v-model="form.storeId" filterable placeholder="请选择">-->
<!--            <el-option-->
<!--                    v-for="item in options"-->
<!--                    :key="item.value"-->
<!--                    :label="item.label"-->
<!--                    :value="item.value">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="姓名">-->
<!--          &lt;!&ndash;<span>{{form.userName}}</span>&ndash;&gt;-->
<!--          <el-input v-model="form.userName" placeholder=""></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="性别">-->
<!--          <el-radio-group v-model="form.sex">-->
<!--            <el-radio label="男"></el-radio>-->
<!--            <el-radio label="女"></el-radio>-->
<!--          </el-radio-group>-->
<!--        </el-form-item>-->
<!--        &lt;!&ndash; <el-form-item label="出生年月日">-->
<!--          <span>2016年7月</span>-->
<!--        </el-form-item> &ndash;&gt;-->
<!--        <el-form-item label="手机号">-->
<!--          <el-input :class="$style.phone" v-model="form.phone" type="number" placeholder=""></el-input>-->
<!--          &lt;!&ndash;<span>{{// form.phone}}</span>&ndash;&gt;-->
<!--        </el-form-item>-->
<!--        <el-form-item label="开始销售日立时间">-->

<!--          <el-date-picker-->
<!--                  v-model="info.startSalesDate" format="yyyy-MM-dd"-->
<!--                  type="date"-->
<!--                  placeholder="">-->
<!--          </el-date-picker>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="店长">-->
<!--          <el-switch-->
<!--                  v-model="storeManager"-->
<!--                  active-color="#13ce66"-->
<!--                  inactive-color="#ff4949">-->
<!--          </el-switch>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="在职">-->
<!--          <el-switch-->
<!--                  v-model="isON"-->
<!--                  active-color="#13ce66"-->
<!--                  inactive-color="#ff4949">-->
<!--          </el-switch>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="离职原因" v-show="!isON">-->
<!--          <el-select v-model="form.quit_reason" filterable placeholder="请选择" value-key="_id">-->
<!--            <el-option-->
<!--                    v-for="item in quitReasons"-->
<!--                    :key="item._id"-->
<!--                    :label="item.quit_reason"-->
<!--                    :value="item.quit_reason">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="冻结账号">-->
<!--          <el-switch-->
<!--                  v-model="lock"-->
<!--                  active-color="#13ce66"-->
<!--                  inactive-color="#ff4949">-->
<!--          </el-switch>-->
<!--        </el-form-item>-->
<!--      </el-form>-->
<!--    </el-dialog>-->
  </div>
</template>
<script>
import http from '../../APIService/http'
import {bus} from '../../router/index'
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    options: {
      type: Array,
      default: () => []
    },
    quitReasons: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      loading:false,
      showModal: false,
      form: {

      },
      storeManager: false,
      isON: false,
      lock: false,
      data:{},
      msg:'removeTrue'
    }
  },
  // mounted(){
  //   // console.log(this.info)
  //   if (this.info.category === "SYSTEM"){
  //     this.info.category = '地区经理'
  //   } else {
  //     this.info.category = '地区经理'
  //   }
  //   console.log(this.info,1111)
    // if(this.info.gender === s"T"){
    //   this.info.sex = '女'
    // }else{
    //   this.info.sex = '男'
    // }
    // var str = this.info.birthday
    // var curDate = new Date();
    // var curYear =curDate.getFullYear();  //获取完整的年份(4位,1970-????)

  // },
  filters:{
    filtersex:function (o) {
      if(o && o === "T"){
        return '女'
      } else if(o && o === "M"){
          return '男'
      }else{
        return ""
      }
    },
    filtertime:function (a) {
        var o = a.trim()
      if(o){
        var str = o.split('')[0]+o.split('')[1]+o.split('')[2]+o.split('')[3]
        var curDate = new Date();
        var curYear =curDate.getFullYear();
        return Number(curYear - str)+'岁'
      }else{
        return ""
      }

    },

  },
  methods: {

    // 移除按钮
   async handleEditClick () {
     let data ={...this.info}
     data.territory_id =this.data.territory_id

     await http.post('/wapi/JurActive/removePeople',data).then(res=>{
       if (res.success === true){
         this.$message({
           type: 'success',
           message: '移除成功'
         })
         let obj = this.$store.getters.getDataInfo
         for(let i=0;i<obj.salseList.length;i++){
           if (data.user_id === obj.salseList[i].manager_id ) {
             obj.salseList.splice(i,1)
           }
         }
         let length = obj.salseList.length
         this.$emit('getPeople')
         bus.$emit('changeTreeList',new Date())
         bus.$emit('changeList',new Date())
         bus.$emit('getPeopleLength',length)
       }
     })

      // this.form = {...this.info}
      // if (!('storeManager' in this.form)) {
      //   this.storeManager = false
      // } else {
      //   this.storeManager = this.form.storeManager
      // }
      //
      // if (!('lock' in this.form)) {
      //   this.lock = false
      // } else {
      //   this.lock = this.form.lock
      // }
      //
      // if (this.form.status === 'ACTIVE') {
      //   this.isON = true // 是否在职
      // } else {
      //   this.isON = false
      // }
      // this.showModal = true
    },
    // 关闭模态框
    closeModal () {
      this.showModal = false
    },
    // 保存按钮
    handleSaveClick () {
      this.update()

    },
    // 编辑店员
    async update () {
      try {

        let storeName = this.form.storeName
        for (let i = 0; i < this.options.length; i++) {
          let item = this.options[i]

          // if (item.value === this.form.storeId) {
          //   storeName = item.label
          //   break
          // }
          if (item.value === this.form.storeId) {
            this.form.storeId = item.value
            storeName = item.label
            break
          }
        }
          let quitReason = ''
          if(!this.isON){//离职
              if(this.form.quit_reason !== ''){
                  quitReason = this.form.quit_reason
              }else {
                  this.$message({
                      type: 'error',
                      message: '请选择离职原因'
                  })
                  return
              }
          }
        let params = {
          'type': 'users',
          storeId: this.form.storeId,
          storeName,
          userName:this.form.userName,
          sex:this.form.sex,
          phone:this.form.phone,
          startSalesDate:this.info.startSalesDate ? new Date(this.info.startSalesDate).Format('yyyy-MM-dd') : '',
          storeManager: this.storeManager,
          lock: this.lock,
          status: this.isON ? 'ACTIVE' : 'INACTIVE',
          quitReason: quitReason
        }
        let res = await http.put(`/wapi/v1/teacher/store/${this.form.userId}`, params)

        if (res.status === 200) {
          this.$emit('increment', this.form.storeId)
          this.$message({
            type: 'success',
            message: '修改成功'
          })
            this.showModal = false
        } else {
          throw new Error('error')
        }
      } catch (err) {
        this.error('修改失败')
      }
    }
  },
  mounted() {
    this.data = this.$store.getters.getDataInfo
    // console.log(this.info,111)
    if (this.info.category === "SYSTEM"){
      this.info.category = '地区经理'
    } else {
      this.info.category = '地区经理'
  }
    // if(this.info.gender === "T"){
    //     this.info.sex = '女'
    //   }else{
    //     this.info.sex = '男'
    //   }
    //   var str = this.info.birthday
    //   var curDate = new Date();
    //   var curYear =curDate.getFullYear();  //获取完整的年份(4位,1970-????)
}
}
</script>
<style lang="scss" module>
  @import '../../assets/css/default';
  .container {
    border:1px solid #979797;
    width: 300px;
    height: 80px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-bottom: 20px;
    .header {
      padding: 10px;

      &:after{
        display: block;
        content: '';
        overflow: hidden;
        clear: both;
      }
      .avatar {
        font-size:40px;
        color:#f49557;;
        float:left
      }
      .edit {
        color:red;
        font-size:14px;
        float:right;
        cursor: pointer;
      }
      .userInfo {
        span {
          font-size:14px;
          font-weight: bold;
          color:#2a363b;
          vertical-align: middle;
        }
        .frozen {
          font-size:12px;
          color: #fff;
          padding: 3px;
          background: #d1021b;
          border-radius: 3px;
        }
        .tip {
          font-size:12px;
          color: #fff;
          padding: 3px;
          background: #ff9801;
          border-radius: 5px;
        }
        p {
          margin: 10px 0px 0px;
          color:#717d84;
          opacity:0.6;
          .tel {
            font-size: 16px;
            margin-right:3px;
            margin-left:8px;
          }
          .tel1 {
             font-size: 16px;
             margin-right:3px;
             margin-left:0px;
           }
        }
      }
    }
    .body {
      p {
        margin:0 10px 10px 16px;
        color: #9da4ad;
        font-size:15px;
        font-weight: normal;
        .date {
          margin-left: 4px;
          color: #a2e065;
          &:after {
            display: inline-block;
            content: '';
            overflow: hidden;
            clear: both;
          }
        }
      }
    }
    .modal {
      .title {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: center;
        >span {
          color:#3998f7;
          font-size:$fontSize;
        }
      }
      .phone{
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none !important;
          margin: 0;
        }
      }
    }
  }
</style>

<style scoped>
  .a_modal >>> form {
    text-align: left;
    width: 90%;
    margin: 0 auto;
  }
  .a_modal >>> .el-dialog__header {
    border-bottom: 2px dotted #e7eaec;
  }
  .a_modal >>> .el-form-item__label {
    color:#000000;
    font-size: 16px;
    /* width: 140px!important; */
    text-align: right;
  }
  .a_modal >>> .el-select {
    width:100%;
  }
  .a_modal >>> .el-form-item__content {
    color: #4a90e2;
    font-size: 16px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/pages/jurmanage/boxItem.vue